import React, { useState, useContext, useEffect, useCallback } from "react";
import { AppContext, DispatchContext } from '../../AppContext';
import TitleBar from '../../components/titleBar';
import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import ReportPropertiesForm from "../../components/ReportPropertiesForm";
import TextFieldPanel from "../../components/TextFieldPanel";
import EditSharpIcon from '@material-ui/icons/EditSharp';
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import AutoExcludeSourcesDialog from "../../components/AutoExcludeSourcesDialog";
import AutoAcceptSourcesDialog from "../../components/AutoAcceptSourcesDialog";
import Service from "../../services/service"
import * as actions from '../../actions/actions';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import IconButton from '@material-ui/core/IconButton';
import PublicIcon from '@material-ui/icons/Public';
import LibraryBooksSharpIcon from "@material-ui/icons/LibraryBooksSharp";
import SearchIcon from '@material-ui/icons/Search';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { ReactComponent as CoinsIcon } from '../../assets/coins.svg';
import LoadingScreen from '../../components/LoadingScreen';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import NewProjectForm from "../../components/NewProjectForm";
import ProjectsDialog from "../../components/ProjectsDialog";
import EditIcon from '@material-ui/icons/Edit';
import { resolveNotificationMessage } from '../../helpers/constants';
import { ReactComponent as UploadingIcon } from '../../assets/icons/uploading.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/download.svg';
import { ReactComponent as ClipboardIcon } from '../../assets/icons/clipboard.svg';
import { ReactComponent as BooksIcon } from '../../assets/icons/books.svg';
import DividerLabel from "../../components/DividerLabel";


const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    position: "relative",
  },
  main_container: {
    display: 'flex',
    height: '100%',
    flex: "1 1 auto",
    overflow: 'hidden',
    overflowX: 'auto'
    
  },
  selectSourcesPanel: {
    flex: "0 0 auto",
    width: 320,
    minWidth: 320,
    backgroundColor: "white",
  },
  centerPanel: {
    flex: '1 1 auto',
    padding: theme.spacing(1)
  },
  detailsPanel: {
    flex: "0 0 auto",
    flexDirection: "column",
    width: 350,
    minWidth: 350,
    backgroundColor: "white",
    display: "flex",
    overflowY: "auto",
  },
  startSearchPanel: {
    flex: "0 0 auto",
    padding: theme.spacing(1),
    textAlign: "center",

  },
  centerAlign: {
    textAlign: "center"
  },
  button: {
    width: "100%"
  },
  button_size: {
    width: '100%',
    height: "80px",
  },
  data: {
    paddingTop: "15px",
    paddingLeft: "11px"
  },
  expansion_details: {
    padding: "16px !important",
  },
  update_padding: {
    padding: 0,
  },
  pannelSummary: {
    padding: "0 16px",
  },
  propertiesPanel: {
    flex: "1 1 auto",
    minHeight: 0,
    height: 0,
    overflowY: "auto",
    padding: theme.spacing(1),
  },
  ToggleSourcesButtons: {
    width: "100%",
    padding: theme.spacing(2),
  },
  toggleButtonSize: {
    height: "80px",
    color: theme.palette.primary.main,
    display: "flex",
    justifyContent: "start"
  },

  selectedToggleButton: {
    color: theme.palette.primary.main + " !important",
  },

  button_overlay: {
    position: 'relative'
  },
  alignInRow: {
    display: "flex"
  },
  publicIcon: {
    marginRight: "5px",
    color: "#0D4A81"
  },
  notInterestedIcon: {
    margin: "0 0 -5px 0",
  },
  checkCircleIcon: {
    color: "#017d01",
    margin: "0 0 -5px 0",
  },
}))

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);


const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    width: "100%",
    backgroundColor: '#ffffff',
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#F7F7F7",
    borderBottom: "1px solid #E6E6E6",
    marginBottom: -1,
    minHeight: 40,
    height: 40,
    "&$expanded": {
      minHeight: 40,
      height: 40,
      backgroundColor: "#E6E6E6",
    },
    '&:hover': {
      cursor: "pointer",
      backgroundColor: "#EEEEEE",
      transition: 'background-color 0.2s',
    },
  },

  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const newTextSource = [
  { id: "upload", icon: <UploadingIcon fill="#0D4A81" height={50} width={50} style={{ margin: 16 }} /> },
  { id: "text", icon: <ClipboardIcon fill="#0D4A81" height={50} width={50} style={{ margin: 16 }} /> },
  { id: "download", icon: <DownloadIcon fill="#0D4A81" height={50} width={50} style={{ margin: 16 }} /> }
];

export default function NewLibraryText() {
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles(state);
  const dispatch = useContext(DispatchContext);
  const [expanded, setExpanded] = React.useState("panel1");
  const [loadingScreen, setLoadingScreen] = useState(false);

  const changePanel = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {

    if (state.ui.pageName !== window.location.pathname) {
      dispatch(actions.navigate_to(window.location.pathname));
      dispatch(actions.setUI({ plagCheckMenuExpanded: true }));
    }

    return () => {
      setLoadingScreen(false);
    };
  }, []);

  useEffect(() => {
    updateCreditCosts();
  }, [JSON.stringify(state.newTextSettings), JSON.stringify(state.uploadedFilesStatus)]);


  // to change the active toggle button
  const changeToggleButton = (e, newSource) => {
    if (newSource) {
      if ((state.newTextSettings.text.trim() !== '') ||
        (state.newTextSettings.source == 'upload' && state.uploadedFiles.length > 0)
      ) {
        dispatch(actions.openConfirmationDialog({
          title: s.newCheck.changeInputSource,
          text: s.newCheck.changeInputSourceHint,
          onConfirm: () => onConfirmChangeSource(newSource),
        }));
        return false;
      }
      onConfirmChangeSource(newSource);
    }
  }

  const textChanged = useCallback((text) => {
    dispatch(actions.setNewTextSettings({ text: text }));
  });

  const onConfirmChangeSource = (newSource) => {
    dispatch(actions.setNewTextSettings({ source: newSource, text: '' }));
  }

  const addTexts = () => {

    setLoadingScreen(true);

    let apiData = {
      author: state.draftReport.Author,
      comment: state.draftReport.Comment,
      projectid: state.draftReport.ProjectId,
      name: state.draftReport.Name,
    };

    switch (state.newTextSettings.source) {
      case 'text':
      case 'download':
        apiData = { ...apiData, text: state.newTextSettings.text };
        break;
      case 'upload':
        apiData = { ...apiData, uploadids: state.uploadedFilesStatus.filter(file => file.Status == "Ok").map(file => file.UploadId) };
        break;
    }

    Service.AddTextsToLibrary(apiData).then(res => {
      setLoadingScreen(false);
      if (res.success) {
        let message = s.notificationMessage.addedToLibrary;
        let type = 'success';
        if (res.message === 'notificationMessage.textsAdded') {
          type = 'success';
          message = s.notificationMessage.textsAdded.format(res.total);
        } else if (res.message === 'notificationMessage.textsSkipped') {
          type = 'warning';
          message = s.notificationMessage.textsSkipped.format(res.total);
        }
        dispatch(actions.setDraftReport({}));
        dispatch(actions.setNewTextSettings({ text: ''}));
        dispatch(actions.navigate_to('/library/overview'));
        dispatch(actions.openToast({ type: type, message: message, status: true }));
      }
    })
  }


  const updateCreditCosts = () => {
    let apiData = { web: 1, lib: 1 };
    switch (state.newTextSettings.source) {
      case 'text':
      case 'download':
        apiData = { ...apiData, text: state.newTextSettings.text };
        break;
      case 'upload':
        apiData = { ...apiData, uploadids: state.uploadedFilesStatus.filter(file => file.Status == "Ok").map(file => file.UploadId) };
        break;
    }
    Service.calculateCredits(apiData).then(res => {
      if (!res.success) {
        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage), status: true }));
      }
      dispatch(actions.setCreditCosts(res.data));
    });
  };

  let addTextsButtonEnabled = state.creditCosts.credits > 0;
  if (addTextsButtonEnabled) {
    let fileStatusCount = state.uploadedFilesStatus.filter(file => file.Status === "Ok")
    if (state.uploadedFiles.length !== fileStatusCount.length) {
      addTextsButtonEnabled = false;
    }
  }

  return (
    <div className={classes.root}>
      <TitleBar title={s.newText.addToLibraryTitle} />
      <div className={classes.main_container}>
        <div className={classes.selectSourcesPanel}>
          <ToggleButtonGroup orientation="vertical" value={state.newTextSettings.source} exclusive onChange={changeToggleButton} className={classes.ToggleSourcesButtons}>
            {newTextSource.map(tab => {
              return (
                <ToggleButton key={tab.id} value={tab.id} aria-label={tab.id} classes={{ root: classes.toggleButtonSize, selected: classes.selectedToggleButton }} >
                  {tab.icon}
                  {s.newCheck[tab.id]}
                </ToggleButton>
              )
            })}
          </ToggleButtonGroup>
        </div>
        <div className={classes.centerPanel}>
          <TextFieldPanel text={state.newTextSettings.text} source={state.newTextSettings.source} textChanged={textChanged} />
        </div>
        <div className={classes.detailsPanel}>
          <div className={classes.startSearchPanel}>
            <div className={classes.button_overlay}>
              <div className={classes.button}>
                <LoadingScreen status={loadingScreen} />
                <Button className={classes.button_size}
                  type="submit"
                  size="large"
                  variant="contained"
                  color="primary"
                  onClick={addTexts}
                  endIcon={< SearchIcon />}
                  disabled={!addTextsButtonEnabled}>
                  {s.newText.addToLibrary}
                </Button>
              </div>
              {state.creditCosts && state.creditCosts.words != 0 ?
                <div className={classes.data}>
                  <div>
                    {s.newCheck.requiredCredits.format(state.creditCosts.words, state.creditCosts.pages, state.creditCosts.documents)}
                  </div>
                </div> :
                < div className={classes.data}>
                  <div>
                    {s.newCheck.requiredCredits.format(0, 0, 0)}
                  </div>
                </div>
              }
            </div>
          </div>
          <div className={classes.propertiesPanel}>
            <Accordion
              expanded={expanded === "panel1"}
              onChange={changePanel("panel1")}>
              <AccordionSummary
                className={classes.pannelSummary}
                aria-controls="panel1d-content"
                id="panel1d-header">
                {s.documentProperties}
              </AccordionSummary>
              <AccordionDetails className={classes.expansion_details}>
                <ReportPropertiesForm className={classes.update_padding} report={state.draftReport} validation={true} />
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  )
}